module.exports = __webpack_public_path__ + "static/media/Logo-chingo-dental.5ddc5573.png";